import React, { ReactNode } from 'react';
import { ErrorBoundary as ReactErrorBoundary } from 'react-error-boundary';
import { ErrorUI } from 'components';

type TPossibleError = Error;

interface ErrorBoundaryProps {
    children: ReactNode;
}

const ErrorBoundary: React.FC<ErrorBoundaryProps> = ({ children }) => {
    const handleError = (error: TPossibleError, errorInfo: { componentStack: string }) => {
        console.error('Error caught by ErrorBoundary:', error, errorInfo);
    };

    const FallbackComponent = ({ error }: { error: TPossibleError }) => (
        <div className="flex items-center justify-center h-screen w-screen">
            <ErrorUI error={error} />
        </div>
    );

    return (
        <ReactErrorBoundary FallbackComponent={FallbackComponent} onError={handleError}>
            {children}
        </ReactErrorBoundary>
    );
};

export default ErrorBoundary;